export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20atmosphere%20with%20warm%20golden%20stage%20lights%20and%20film%20reel%20elements%2C%20elegant%20velvet%20curtains%2C%20dramatic%20lighting%2C%20luxurious%20cinema%20interior%20with%20rich%20textures%2C%20no%20text%2C%20atmospheric%20composition%20with%20deep%20shadows%20and%20warm%20highlights%2C%20professional%20photography&width=1800&height=900&seq=hero-bg-2026-mv&orientation=landscape"
          alt="蘑菇影视影院氛围"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
              <i className="ri-fire-line text-primary-500 text-sm"></i>
              <span className="text-xs font-medium text-primary-400 whitespace-nowrap">日更海量高清影视资源</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-[56px] font-heading text-white leading-tight">
              蘑菇影视 · 高清超清免费在线观看
            </h1>

            <p className="mt-2 text-lg md:text-xl text-primary-400 font-heading">
              4K蓝光无广告 · 流畅不缓冲
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-300/80 leading-relaxed max-w-[560px] mx-auto lg:mx-0">
              蘑菇影视汇聚海量高清、超清、4K、蓝光画质的电影电视剧资源，覆盖动作、科幻、喜剧、悬疑、动漫等全类型内容。每日更新热门新片与经典佳作，全程无广告干扰，播放流畅不缓冲，为您打造极致的免费在线观影体验。无论您是追剧达人还是电影爱好者，这里都是您发现精彩影视世界的理想入口。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-5 justify-center lg:justify-start">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500/20">
                  <i className="ri-movie-line text-accent-500"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-400">影片总量</p>
                  <p className="text-sm font-bold text-white whitespace-nowrap">10万+</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/20">
                  <i className="ri-4k-line text-primary-500"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-400">4K画质覆盖</p>
                  <p className="text-sm font-bold text-white whitespace-nowrap">85%+</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500/20">
                  <i className="ri-shield-check-line text-accent-500"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-400">无广告纯净观影</p>
                  <p className="text-sm font-bold text-white whitespace-nowrap">100%</p>
                </div>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#index"
                className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-play-circle-line mr-2"></i>
                立即观影
              </a>
              <a
                href="#ranking"
                className="px-8 py-3.5 border border-foreground-300/30 hover:border-foreground-300/60 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-fire-line mr-2"></i>
                查看热播榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20film%20poster%20style%20composition%20with%20golden%20film%20reel%20and%20projector%20light%20beam%2C%20dramatic%20warm%20spotlight%20effect%2C%20dark%20theater%20background%2C%20luxurious%20and%20artistic%20movie%20aesthetic%2C%20rich%20textures%2C%20no%20text%2C%20professional%20editorial%20photography%20with%20volumetric%20lighting&width=800&height=1066&seq=hero-visual-mv-2026&orientation=portrait"
                alt="蘑菇影视主视觉 - 影院级观影体验"
                className="w-full h-auto rounded-2xl"
              />
              <div className="absolute -bottom-4 -left-4 bg-background-50/10 backdrop-blur-md rounded-xl p-4 border border-white/10 hidden lg:block">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500">
                    <i className="ri-4k-fill text-white text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-300">最高支持</p>
                    <p className="text-sm font-bold text-white whitespace-nowrap">4K HDR 蓝光</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}